import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface ButtonSelectorOption {
    value: string;
    label: string;
}

@Component({
    selector: 'app-button-selector',
    templateUrl: './button-selector.component.html',
    styleUrls: ['./button-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ButtonSelectorComponent),
            multi: true,
        },
    ],
})
export class ButtonSelectorComponent implements ControlValueAccessor {
    @Input() options: ButtonSelectorOption[] = [];
    @Input() idPrefix = 'button-selector';
    @Input() name = 'button-selector';
    @Input() disabled = false;

    selectedValue: string | null = null;

    /* eslint-disable @typescript-eslint/no-empty-function */
    private onChangeFn: (value: string) => void = () => {};
    private onTouchedFn: () => void = () => {};
    /* eslint-enable @typescript-eslint/no-empty-function */

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    select(value: string): void {
        this.selectedValue = value;
        this.onChangeFn(value);
    }

    onBlur(): void {
        this.onTouchedFn();
    }

    writeValue(value: string | null): void {
        this.selectedValue = value;
        this.changeDetectorRef.markForCheck();
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        this.changeDetectorRef.markForCheck();
    }

    trackByValue(index: number, option: ButtonSelectorOption): string {
        return option.value;
    }
}
